import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// material-ui
import { Button, DialogContent, Dialog, DialogActions, Typography, Box } from '@mui/material'

// third party
import { useSnackbar } from "notistack";

// project import
import { useEventBusContext } from 'services/provider/EventBusProvider'
import { EVENT_ORDER_DELETE_INIT, EVENT_ORDER_UPDATE_SUCCESS } from '../../models/events/order.event';
import { orderDelete } from '../../models/order';
import { useNavigate } from 'react-router-dom'; // Changed from useHistory

/*
 * Initiate service delete dialog.
 */
export const OrderDeleteDialog = () => {
    const eventbus = useEventBusContext()
    const [servicedelete, setServiceDelete] = useState(null)

    useEffect(() => {
        return eventbus.on(EVENT_ORDER_DELETE_INIT, (data) => {
            setServiceDelete(data)
        })
    }, [eventbus])

    return (
        <Dialog open={servicedelete != null} scroll={'body'} maxWidth="sm" fullWidth={true} onClose={() => setServiceDelete(null)} >
            {servicedelete && <OrderDelete servicedelete={servicedelete} onClose={() => setServiceDelete(null)} 
                onSuccess={(data) => {
                    eventbus.fire(EVENT_ORDER_UPDATE_SUCCESS, data)
                    setServiceDelete(null)
                }} 
            />}
        </Dialog>
    )
}

/**
 * Service delete dialog. 
 */
const OrderDelete = ({ servicedelete, onClose, onSuccess }) => {
    const service = servicedelete;
    const { enqueueSnackbar } = useSnackbar();
    const [isDeleting, setIsDeleting] = useState(false);
    const navigate = useNavigate(); // Changed from useHistory

    const onSubmit = async () => {
        setIsDeleting(true);
        try {
            const res = await orderDelete(service.id);
            
            // Show success message
            enqueueSnackbar(res.message || 'Order deleted successfully', { 
                variant: 'success', 
                autoHideDuration: 2000 
            });

            // Fire success event
            onSuccess(res.data);

            // Redirect to list page
            navigate('/orders');
            
        } catch (res) {
            enqueueSnackbar(res.message || 'Failed to delete order', { 
                variant: 'error', 
                autoHideDuration: 2000 
            });
            setIsDeleting(false);
        }
    }

    return (
        <Box>
            <DialogContent dividers sx={{ px: 4, py: 4 }}>
                <Typography variant="h5" sx={{ pr: 2 }}>
                    Are you sure you want to delete this order?
                </Typography>
                <Typography variant="h5" sx={{ mt: 2, color: 'text.secondary' }}>
                    Order ID: <strong>{service?.order_number || 'Unknown'}</strong>
                </Typography>
                <Typography variant="h6" sx={{ mt: 1 }}>
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 1.5 }}>
                <Button onClick={onClose} type="button" variant="outlined" color="secondary" disabled={isDeleting}>
                    Cancel
                </Button>
                <Button type="submit" variant="contained" color="error" onClick={onSubmit} disabled={isDeleting} >
                    {isDeleting ? 'Deleting...' : 'Delete Order'}
                </Button>
            </DialogActions>
        </Box>
    )
}

// OrderDelete component prop type declaration
OrderDelete.propTypes = {
    servicedelete: PropTypes.object, // Fixed typo: was OrderDelete
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default OrderDelete